import Vue from 'vue'

const mutationMethods = {
    TOGGLE_DARK: 'toggle-dark'
}

export const theme = {
    namespaced: true,
    state: {
        dark: false
    },
    actions: {
        toggleDark({commit}) {
            commit(mutationMethods.TOGGLE_DARK)
        }
    },
    mutations: {
        [mutationMethods.TOGGLE_DARK](state) {
            Vue.set(state, 'dark', !state.dark)
        }
    },
    getters: {
        isDarkTheme: state => state.dark
    }
}